<template>
    <v-container fluid ma-0 pa-0>
        <v-img max-height="600" :src="challenge.imgBase64">
            <!--<v-layout align-end justify-end fill-height>
                <v-flex class="text-xs-right">
                    <v-btn color="pink" dark large @click="navigate">Register here</v-btn>
                </v-flex>
            </v-layout>-->


        </v-img>
        <v-container grid-list-sm text-xs-left>


            <v-layout row wrap pa-2>
                <v-flex xs12 pa-3>
                    <span style="text-align: justify" :class="isMobile() ? 'display-1' :'display-3'"><strong>{{challenge.Title.replace('OIC 11 ','')}}</strong></span>
                </v-flex>
                <v-flex xs12 pa-3>
                    <span class="headline"><strong>Challenge expiration date: </strong> {{challenge.date}}</span>
                </v-flex>
                <v-flex xs12 pa-3>
                    <span class="headline"><strong>Description</strong></span>
                    <span style="text-align: justify" class="headline" v-html="challenge.Description"></span>
                </v-flex>
                <v-flex xs12 pa-3>
                    <div class="center-element">
                        <span class="headline"><strong>Tags: </strong></span>
                        <v-chip dark color="primary" v-for="tag in challenge.tags">{{tag}}</v-chip>
                    </div>


                </v-flex>

                <v-flex class="text-xs-center" pt-5>
                    <v-btn color="pink" dark large @click="openStartupRegisteredTreeViewDialog(challenge)">Discover the selected startups</v-btn>
                </v-flex>

            </v-layout>

        </v-container>

        <!-- TreeView for Registered Startups -->
        <v-dialog
                v-model="startupRegisteredTreeViewDialog"
                max-width="1200"
                scrollable
        >
            <v-card>
                <v-card-title class="headline">Selected Startup</v-card-title>
                <v-card-text>
                    <span class="subheading">Click on startup's name to see details</span>
                    <StartupGhostTreeView :challenge='selectedChallenge'></StartupGhostTreeView>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            flat="flat"
                            @click="closeStartupRegisteredTreeViewDialog()"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

</template>

<script>
    import StartupGhostTreeView from "@/pages/Admin/GhostPage/StartupGhostTreeView";
    import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
    import TimeService from "@/helpers/TimeService";
    import UrlsService from "@/helpers/UrlsService";
    import {mapGetters, mapState} from "vuex";

    export default {
        name: "GhostChallengeDetails",
        components: {StartupGhostTreeView},
        props: {
            _id: String,
        },
        computed: {
            ...mapState({}),
            ...mapGetters("UserState", {
                user: "getUserInfo",
            }),
        },
        data() {
            return {
                challenge: {
                    Title: "",
                    Description: "",
                    imgBase64: "",
                    tags: [],
                    date: new Date().toISOString().substr(0, 10),
                    reward: "",
                    published: false,
                    createdBy: ""
                },
                selectedChallenge: {},
                startupRegisteredTreeViewDialog: false

            }
        },
        created() {
            this.getChallenge();
        },
        methods: {
            isMobile() {
                return this.$vuetify.breakpoint.name === "xs";
            },
            closeStartupRegisteredTreeViewDialog() {
                this.selectedChallenge = {};
                this.startupRegisteredTreeViewDialog = false;
            },
            openStartupRegisteredTreeViewDialog(challenge) {
                this.selectedChallenge = challenge;
                this.startupRegisteredTreeViewDialog = true;
            },
            getChallenge(){
                let requestUrl = {
                    url: UrlsService.challengeOperation,
                    timeout: TimeService.secondsToMillis(0),
                };
                let requestData = {
                    interactionData: {
                        text: "GET_BY_ID",
                        challengeRequest: {
                            challenge: {
                                _id: this._id,
                            }
                        },
                    }
                };
                let requestObject = {
                    type: "normal",
                    urlsInfo: requestUrl,
                    data: {
                        data: requestData,
                    },
                };
                let messages = {
                    title: "Challenge",
                    loading: "Waiting for challenge...",
                    error: "Cannot get challenge...",
                };
                let options = {
                    loadingType: "fullscreen",
                    timeout: TimeService.secondsToMillis(0),
                };
                APILoaderDecoratorService.setLoader(requestObject, messages, options)
                    .then(responseSuccess => {
                        let responseChallenge = responseSuccess.response.challenges[0];
                        this.challenge = responseChallenge
                    });
            }
        }

    }
</script>

<style scoped>

    .center-element {
        display: block;
        align-items: center;
    }

</style>